/**
 * Build a WhatsApp chat URL that respects user's preferred WhatsApp app on Android.
 * Preference is stored in localStorage under "wa_app_pref":
 *   - "wa"  → target com.whatsapp (regular WhatsApp)
 *   - "wab" → target com.whatsapp.w4b (WhatsApp Business)
 *   - "ask" (default) → wa.me (Android picks default / asks)
 *
 * On non-Android (iOS / desktop browsers), always falls back to wa.me.
 */
export function buildWhatsappUrl(number, text = "") {
  const pref = typeof window !== "undefined" ? (localStorage.getItem("wa_app_pref") || "ask") : "ask";
  const t = text ? encodeURIComponent(text) : "";
  const textPart = t ? `?text=${t}` : "";
  const isAndroid = typeof navigator !== "undefined" && /android/i.test(navigator.userAgent || "");
  const fallback = `https://wa.me/${number}${textPart}`;

  // Intent URLs only on real Android (not in PWA standalone where they get blocked
  // as opaque navigations). On installed PWAs we keep wa.me which uses Android's
  // global default app picker and is the most reliable opener.
  const isStandalonePWA = typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)").matches ||
     window.navigator?.standalone === true);

  if (isAndroid && !isStandalonePWA && pref === "wa") {
    return `intent://send?phone=${number}${t ? `&text=${t}` : ""}#Intent;scheme=whatsapp;package=com.whatsapp;end`;
  }
  if (isAndroid && !isStandalonePWA && pref === "wab") {
    return `intent://send?phone=${number}${t ? `&text=${t}` : ""}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`;
  }
  return fallback;
}

export function getWaAppPref() {
  if (typeof window === "undefined") return "ask";
  return localStorage.getItem("wa_app_pref") || "ask";
}
